<template>
  <svg width="800px" height="800px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" >
    <path d="M0 0h48v48H0z" fill="none"/>
    <g id="Shopicon">
      <path d="M8,40h32c2.2,0,4-1.8,4-4V12c0-2.2-1.8-4-4-4H8c-2.2,0-4,1.8-4,4v24C4,38.2,5.8,40,8,40z M39.172,12L24,27.172L8.828,12 H39.172z M8,16.828l16,16l16-16V36H8V16.828z" fill="currentColor"/>
    </g>
    </svg>
</template>